/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "alert-warning-white",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#FFFFFF"
            },
            "alertWarningWhite": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "24",
            "height": "24"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: "alert-warning-white", width: this.props.width, height: this.props.height, style: this.props.alertWarningWhite },
            _react2["default"].createElement("path", { className: "st0", d: "M23.4 18.2c.3.5.5 1 .5 1.4 0 .4 0 .8-.2 1.2-.2.3-.5.6-.9.8-.4.2-.9.3-1.5.3H2.6c-.6 0-1.1-.1-1.5-.3-.4-.2-.7-.5-.9-.8-.2-.3-.3-.7-.2-1.2 0-.4.2-.9.5-1.4l9.1-15c.3-.5.7-.9 1.1-1.1.4-.3.8-.4 1.2-.4.4 0 .8.1 1.2.4.4.3.8.6 1.1 1.1l9.2 15zM13.2 7h-2.4v7.2h2.4V7zm0 8.9h-2.4v2.4h2.4v-2.4z", style: this.props.st0 }),
            _react2["default"].createElement("path", { fill: "transparent", d: "M10.8 7h2.4v7.2h-2.4zM10.8 15.9h2.4v2.4h-2.4z" })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/alert-warning-white.js